<template>
  <div class="dress-well-details">
    <div class="details">
      <div class="details-l common-flex">
        <div class="details-img-list">
          <div
            class="img-list-item"
            @click="changeImg(index)"
            v-for="(item, index) in imgList"
            :key="index"
            :class="carouselValue == index ? 'img-list-select' : 'img-list-fff'"
          >
            <img
              class="details-s-img"
              v-lazy="item"
              :alt="productDetails.goodName"
            />
          </div>
        </div>
        <div @click="previewImg" class="main-img-container">
          <Carousel autoplay v-model="carouselValue" class="details-b-img" >
            <CarouselItem v-for="(item, index) in imgList" :key="index">
              <img
                @error="errorImg($event)"
                class="details-b-img"
                :src="item"
                :alt="productDetails.goodName"
              />
            </CarouselItem>
          </Carousel>
        </div>
      </div>
      <div class="details-r">
        <div class="common-flex common-justify-between common-align-center product-header">
          <div class="details-r-name">{{ productDetails.goodName }}</div>
          <div class="details-r-id">ID:{{ productDetails.goodSku }}</div>
        </div>
        <div class="details-r-price">
          {{ productDetails.currency }}{{ productDetails.price }}
        </div>
        <div
          class="select-item common-flex common-align-center"
          v-if="specs.length > 0"
        >
          <div class="details-title">Size</div>
          <Select
            v-model="size"
            size="large"
            placeholder="SELECT"
            class="select-control"
          >
            <Option v-for="item in specs" :value="item" :key="item">{{
              item
            }}</Option>
          </Select>
        </div>
        <div
          class="select-item common-flex common-align-center"
          v-if="colors.length > 0"
        >
          <div class="details-title">Color</div>
          <Select
            v-model="color"
            size="large"
            placeholder="SELECT"
            class="select-control"
          >
            <Option v-for="item in colors" :value="item" :key="item">{{
              item
            }}</Option>
          </Select>
        </div>
        <div class="select-item common-flex common-align-center">
          <div class="details-title">Qty</div>
          <form>
            <InputNumber
              :min="1"
              :max="99"
              v-model="value"
              controls-outside
              class="qty-control"
            />
          </form>
        </div>
        <div class="button-container">
          <Button class="details-buy-now" :loading="loading" @click="buy">Buy Now</Button>
          <Button class="details-add-cart" :loading="cartLoading" @click="addToCart">Add to Cart</Button>
        </div>
        <p class="property-goodDetail" v-html="productDetails.property"></p>
      </div>
    </div>
    <p class="details-goodDetail" v-html="productDetails.goodDetail"></p>
  </div>
</template>
<script>
import 'viewerjs/dist/viewer.css'
import { api as viewerApi } from "v-viewer";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      preview: false,
      size: "", //尺码
      color: "", //颜色
      value: 1, //数量
      carouselValue: 0,
      productDetails: "",
      imgList: [],
      colors: [],
      specs: [],
      submitMsg: {
        colors: "",
        quantity: "",
        specs: "",
        id: "",
      },
      loading: false,
      cartLoading: false, // 加入购物车按钮loading状态
      defaultImg: "../../assets/images/none-img.png",
    };
  },
  mounted() {
    this.goodsDetail();
  },
  methods: {
    ...mapActions(["goodsDetailAction", "submitAction", "saveToCartAction"]),
    previewImg() {
      const $viewer = viewerApi({
        options: {
            toolbar: true,
            initialViewIndex: this.carouselValue
          },
        images: this.imgList,
      });
    },
    buy() {
      if (this.colors.length > 0 && this.color === "") {
        // 请选择颜色
        this.$Message.error("请选择颜色");
        return;
      }
      if (this.specs.length > 0 && this.size === "") {
        this.$Message.error("请选择尺码");
        // 请选择尺码
        return;
      }
      this.submitMsg.colors = this.color;
      this.submitMsg.specs = this.size;
      this.submitMsg.quantity = this.value;
      this.submitMsg.id = this.productDetails.id;
      this.loading = true;
      this.submitAction(this.submitMsg)
        .then((res) => {
          // this.$router.push("myOrder");
          this.$Message.success("success");
          this.$Modal.confirm({
          title: "success",
          okText: "Continue purchasing",
          cancelText: "Go to order list",
          onOk: () => {
            // that.loginoutAction();
          },
          onCancel:async () => {
            this.$router.push("underProduction");
        },
        });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addToCart() {
      if (this.colors.length > 0 && this.color === "") {
        // 请选择颜色
        this.$Message.error("请选择颜色");
        return;
      }
      if (this.specs.length > 0 && this.size === "") {
        this.$Message.error("请选择尺码");
        // 请选择尺码
        return;
      }
      this.submitMsg.colors = this.color;
      this.submitMsg.specs = this.size;
      this.submitMsg.quantity = this.value;
      this.submitMsg.id = this.productDetails.id;
      this.cartLoading = true;
      this.saveToCartAction(this.submitMsg)
        .then((res) => {
          this.$Message.success("加入购物车成功");
        })
        .catch((err) => {
          this.$Message.error("加入购物车失败");
        })
        .finally(() => {
          this.cartLoading = false;
        });
    },
    goodsDetail() {
      this.goodsDetailAction({
        id: this.$route.query.id,
      }).then((res) => {
        this.productDetails = res.data;
        if (res.data.colors) {
          this.colors = res.data.colors.split(",");
        }
        if (res.data.specs) {
          this.specs = res.data.specs.split(",");
        }
        this.imgList = res.data.images.split(",");
      });
    },
    errorImg(e) {
      e.srcElement.src = require("../../assets/images/none-img.png");
      //这一句没用，如果默认图片的路径错了还是会一直闪屏，在方法的前面加个.once只让它执行一次也没用
      e.srcElement.onerror = null;
    },
    changeImg(e) {
      this.carouselValue = e;
    },
  },
};
</script>
<style lang="less" scoped>
.dress-well-details {
  background-color: #fff;
}

.details-goodDetail {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 40px 40px;
  position: relative;
  overflow: hidden;
}

.property-goodDetail{
  margin-top: 30px;
  min-height: 100px;
  position: relative;
  overflow-x: hidden;
  
  /* table 样式 */
  /deep/table {
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
    width: 100%;
    margin-top: 15px;
    table-layout: fixed;
  }
  /deep/ table td,
  /deep/ table th {
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    padding: 8px 12px;
  }
  /deep/ table th {
    border-bottom: 2px solid #ccc;
    text-align: center;
    background-color: #f8f8f8;
  }

  /* blockquote 样式 */
  /deep/ blockquote {
    display: block;
    border-left: 8px solid #d0e5f2;
    padding: 5px 10px;
    margin: 10px 0;
    line-height: 1.4;
    font-size: 100%;
    background-color: #f1f1f1;
  }

  /* code 样式 */
  /deep/ code {
    display: inline-block;
    *display: inline;
    *zoom: 1;
    background-color: #f1f1f1;
    border-radius: 3px;
    padding: 3px 5px;
    margin: 0 3px;
  }
  /deep/ pre code {
    display: block;
  }

  /* ul ol 样式 */
  /deep/ ul, ol {
    margin: 10px 0 10px 20px;
  }
}

/deep/.ivu-input-number-input {
  text-align: center;
}

.button-container {
  display: flex;
  margin-top: 40px;
  margin-bottom: 30px;
}

.details-buy-now {
  flex: 1;
  height: 50px;
  background: #081938;
  color: #fff;
  margin-right: 15px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 4px;
  transition: all 0.3s ease;
  
  &:hover {
    background: #0f2b56;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(8, 25, 56, 0.2);
  }
}

.details-add-cart {
  flex: 1;
  height: 50px;
  background: #fff;
  color: #081938;
  border: 1px solid #081938;
  font-size: 16px;
  font-weight: 500;
  border-radius: 4px;
  transition: all 0.3s ease;
  
  &:hover {
    background: #f0f3f9;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(8, 25, 56, 0.1);
  }
}

.img-list-item {
  margin-bottom: 15px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
  }
}

.details-s-img {
  object-fit: contain;
  transition: all 0.2s ease;
}

.img-list-fff {
  border: 1px solid #eee;
  border-radius: 2px;
}

.img-list-select {
  border: 2px solid #0a4dcc;
  border-radius: 2px;
}

.main-img-container {
  cursor: pointer;
}

.select-item {
  margin-bottom: 20px;
}

.select-control {
  width: 180px !important;
}

.qty-control {
  width: 180px !important;
}

.product-header {
  margin-bottom: 10px;
}

.details {
  max-width: 1440px;
  background: #fff;
  padding: 40px 40px 10px 40px;
  margin: 0 auto;
  position: relative;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  
  .details-img-list {
    margin-right: 40px;
  }
  
  .details-l {
    margin-right: 80px;
    position: relative;
    width: 540px;
    flex: 0 0 auto;
    
    .details-s-img {
      width: 100px;
      height: 100px;
      border: 1px solid #eee;
      display: block;
    }
    
    .details-b-img {
      width: 540px;
      height: 660px;
      background: #f8f8f8;
      object-fit: contain;
      border-radius: 4px;
    }
  }
  
  .details-r {
    width: 600px;
    flex: 0 0 auto;
    position: relative;
    overflow-x: hidden;
    
    .details-r-name {
      font-size: 30px;
      font-weight: 500;
      color: #081938;
      line-height: 35px;
    }
    
    .details-r-id {
      font-size: 16px;
      font-weight: 400;
      color: #888;
      line-height: 19px;
    }
    
    .details-r-price {
      margin: 30px 0 40px;
      font-size: 24px;
      font-weight: 500;
      color: #081938;
      line-height: 24px;
      text-align: left;
    }
  }
  
  .details-title {
    width: 83px;
    text-align: left;
    font-size: 16px;
    font-weight: 500;
    color: #081938;
    line-height: 19px;
  }
  
  .details-label-content {
    font-size: 16px;
    font-weight: 400;
    color: #081938;
    line-height: 19px;
    text-align: left;
  }
  
  .details-label-title {
    font-size: 16px;
    font-weight: 600;
    color: #081938;
    line-height: 19px;
    text-align: left;
    margin-bottom: 10px;
  }
}

@media screen and (max-width: 1280px) {
  .details {
    flex-direction: column;
    
    .details-l {
      margin-right: 0;
      margin-bottom: 40px;
    }
    
    .details-r {
      width: 100%;
      max-width: 600px;
    }
  }
}
</style>
<style>
#app {
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/dressWell/dressWellDetails.vue